export default {
  pwmat: {
    title: 'Introduction',
    intrP1: `
            PWmat is a material simulation software package at the atomic scale.
            It is based on first principles and uses plane wave basis sets and pseudopotential methods
            to perform electronic structure calculations and molecular dynamics simulations. More importantly,
            PWmat uses CUDA for GPU optimization acceleration, which is 20 times faster than the same CPU
            software (PEtot, based on BSD open source license), and can perform simulation
            calculations on systems with more than 4,000 electrons on MSTATION.
    `,
    intrP2: `
            PWmat can approximately solve the multi-body Schrödinger equation to obtain the electronic
            state and energy of the system. In the framework of density functional theory (DFT),
            the Kohn-Sham equation is solved using methods such as local density approximation (LDA),
            generalized gradient approximation (GGA), and hybrid functional theory (HSE) approximation.
    `,
    intrP3: `
            The single electron orbitals, electron density, and local potentials in PWmat are all expanded
            using plane wave basis sets, and the electron-ion interaction is described by
            norm-conserving pseudopotentials or ultrasoft pseudopotentials.
    `,
    feature: 'Features',
    fun01name: 'Exchange-correlation functional',
    fun01desc1: 'Hybrid Functional',
    fun02name: 'Structural relaxation and molecular dynamics',
    fun02desc1: 'Lattice and atomic relaxation',
    fun02desc2: 'First',
    fun03name: 'Magnetic computing',
    fun03desc1: 'Linear and nonlinear magnetic calculations',
    fun03desc2: 'Spin-orbit coupling',
    fun04name: 'Mechanical properties',
    fun04desc1: 'Material Equation of State',
    fun04desc2: 'Material phonon spectrum',
    fun05name: 'Electronic structure',
    fun05desc1: 'Band structure and electronic state density',
    fun05desc2: 'Charge density distribution',
    fun06name: 'PWSCF compatible',
    fun06desc1: 'equation',
    fun07desc1: 'Real-time time-dependent density functional simulation',
    fun07desc2: 'Femtosecond molecular dynamics acceleration',
    fun08name: 'Electroacoustic coupling calculation',
    fun08desc1: 'New algorithm describes the interaction of electronic states',
    fun09name: 'solvent effect',
    fun09desc1: 'Various liquid and gas solvent effects',
    fun09desc2: '10 times faster than traditional algorithms',
    app: 'Application',
    appP1: `PWmat can be used to solve the following problems. Some of these applications can be
    directly calculated by PWmat, while others need to be analyzed based on the calculation results of PWmat.
    All these applications only rely on the core functions of PWmat (SCF, NONSCF, DOS, RELAX, MD, NEB)`,
    appR1C1: 'Crystal band structure',
    appR2C1: 'Density of states (DOS)',
    appR3C1: 'The formation energy of a crystalline compound',
    appR4C1: 'Alloy phase diagram',
    appR5C1: 'Phonon spectrum',
    appR6C1: 'Defect Formation Energy and Defect Analysis',
    appR7C1: 'Surface reconstruction and surface energy',
    appR8C1: 'Adsorption and structure of molecules on surfaces',
    appR9C1: 'Band correction',
    appR10C1: 'Superlattice structure simulation',

    appR1C2: 'Quantum Well Effect',
    appR2C2: 'Liquid free energy',
    appR3C2: 'Diffusion of molecules or ions in a liquid',
    appR4C2: 'Cluster structure search',
    appR5C2: 'Crystal structure search',
    appR6C2: 'Thermal conductivity of solids',
    appR7C2: 'Catalytic reactions and intermediates',
    appR8C2: 'Chemical reaction pathways and reaction energy',
    appR9C2: 'Molecular structure of organic matter',
    appR10C2: 'Optical property calculation',

    test: 'Performance Testing',
    testSpeed: 'Speed Test',
    testAccuracy: 'Accuracy Test',

    allinone: 'All-in-one solution',

    try: 'Software Trial',
    tryApply: 'Apply for a Trial License',
    tryMcloud: 'Register for Mcloud trial',

    tutor: 'Software Tutorials',
    tutorStart: 'Quick Start Tutorial',
    tutors: 'Tutorials',
    tutorCase: 'Case Tutorial',
    tutorVideo: 'Video Tutorial',

    link: 'Related links',
    download: 'Download',
    potentialDownload: 'Pseudopotential Download',
    enDownload: 'Download English manual',
    zhDownload: 'Download Chinese manual',
    paper: 'Published papers',
  }
}